<template>
  <div>
    <div
      v-if="isSimplifyMenu"
      class="sub-menu-background-fade w-100 h-100 position-fixed"
      style="left: 0px; top: 0px"
      @click.prevent="closeprimaryResearchModels()"
    />
    <div
      :class="
        isSimplifyMenu
          ? 'gemini-simplify-fixed-submenu'
          : 'horizontalModelSelector'
      "
      ref="horizontalModelSelector"
    >
      <div class="w-100 model-section">
        <div class="row">
          <div class="closeIcon">
            <em
              class="primaryicon-times cursor-pointer"
              @click="hideModelSelector"
            ></em>
          </div>
          <div class="container">
            <p class="headingFont mb-md-2 mb-0 pb-5 pt-3">
              Discover Your INFINITI
            </p>
            <div :class="['row my-3 m-auto', isMobile ? 'w-100' : '']">
              <div class="col-md-3 d-none d-md-block p-0">
                <ul class="p-0">
                  <li v-for="(category, index) in categories" :key="index">
                    <a
                      href="#"
                      @click.prevent="
                        filterModelsByCategory(category.key, index)
                      "
                      :class="[
                        'text-black-50',
                        { activeClass: currentCategoryIndex === index },
                      ]"
                      >{{ category.name }}</a
                    >
                  </li>
                  <li>
                    <a
                      href="/certified-pre-owned-benefits"
                      class="text-black-50"
                    >
                      Certified Pre-Owned
                      <em class="mx-1 primaryicon-right-arrow-light"></em>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="col-md-9 carSection">
                <div class="row">
                  <div
                    class="col-lg-4 col-md-6 model-box p-4"
                    v-for="(model, index) in filteredModels"
                    :key="index"
                  >
                    <a :href="model.inventory" class="no-hover row">
                      <div class="imageSec col-6 col-md-12">
                        <img :src="model.photoURLs" class="img-fluid" />
                      </div>
                      <div
                        class="descScrip px-md-3 p-0 col-6 col-md-12 d-inline-block align-content-center"
                      >
                        <p class="subheading mb-1">
                          {{ model.year }} {{ model.model }}
                        </p>
                        <p class="price-container mb-1">
                          Starting MSRP $ {{ model.startingPrice }}
                          <span
                            @click.prevent="openDisclaimer(model.disclaimer)"
                            >*</span
                          >
                        </p>
                        <div
                          :class="[
                            'linkSec mb-1 pr-3 d-flex justify-content-between',
                            { 'w-75': !isMobile },
                          ]"
                        >
                          <a :href="model.explore">
                            Explore
                            <em class="mx-1 primaryicon-right-arrow-light"></em>
                          </a>
                          <a :href="model.inventory">
                            Purchase
                            <em class="mx-1 primaryicon-right-arrow-light"></em>
                          </a>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overlay active" v-if="modalShow">
        <div class="popup-box">
          <a
            class="close-icon position-absolute no-hover ft-20 font-weight-bold cursor-pointer"
            @click.prevent="closeModal"
            style="right: 10px; top: 10px"
          >
            <i class="color-black primaryicon-times" style="color: #626262"></i>
          </a>
          <div v-if="disclaimer" class="disclaimer-content-text">
            {{ disclaimer }}
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

  <script>
import Modal from "../Shared/Modal/Modal.vue";
import Axios from "axios";

export default {
  components: {
    Modal,
  },
  props: {
    isSimplifyMenu: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  emits: ["hidemodal"],
  data() {
    return {
      modelData: {},
      filteredModels: [],
      currentCategoryIndex: 0,
      isMobile: window.ismobile,
      disclaimer: "",
      modalShow: false,
      categories: [
        { key: "all", name: "All Vehicles" },
        { key: "crossoverandsuvs", name: "Crossovers & SUVs" },
      ],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    hideModelSelector() {
      this.$emit("hidemodal");
    },
    async fetchData() {
      try {
        const response = await Axios.get(
          `${
            window.baseUrl
          }/js/components/infinitModel/infinitiModelConstant.json?v=${this.getTimeStamp()}`
        );
        this.modelData = response.data.model;
        this.filteredModels = [...this.modelData.crossoverandsuvs];
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    closeprimaryResearchModels() {
      this.$emit("hidemodal");
    },
    filterModelsByCategory(key, index) {
      this.currentCategoryIndex = index;
      this.filteredModels =
        key === "all"
          ? [...this.modelData.crossoverandsuvs]
          : this.modelData[key];
    },
    getTimeStamp() {
      return Math.floor(Date.now() / 1000);
    },
    closeModal() {
      this.modalShow = false;
      this.disclaimer = "";
    },
    openDisclaimer(text) {
      this.disclaimer = text;
      this.modalShow = true;
    },
  },
};
</script>

  <style scoped>
.horizontalModelSelector {
  z-index: -1;
  width: 100%;
}
.model-section {
  background: url(https://www.infinitiusa.com/etc/designs/infiniti_nna_v2/24.07.60.NISSAN-10/common-assets/img/horizon_graphics/INFINITI_Primary_HorizonGraphic_RGB_16x9_V1_min.png)
    bottom / 100% no-repeat #efede9;
  padding: 2rem 9rem;
  max-height: calc(100vh - 110px) !important;
  overflow-y: scroll;
  overflow-x: hidden;
}

.headingFont {
  color: #000;
  font-size: 30px;
}
ul {
  list-style-type: none;
}
.model-section ul li {
  margin: 15px 0;
  text-align: left;
}
.closeIcon {
  color: #000;
  position: absolute;
  top: 180px;
  right: 3rem;
}
.gemini-simplify-fixed-submenu .closeIcon {
  color: #000;
  position: absolute;
  top: 45px;
  right: 3rem;
}
.activeClass {
  font-weight: bold !important;
  color: black !important;
  border-bottom: 2px solid;
  text-decoration: none !important;
}

.subheading {
  color: #000;
  font-size: 19px;
  line-height: 26.6px;
  letter-spacing: 0.38px;
}
.linkSec a {
  color: #000000;
  font-size: 13px;
}
.price-container {
  line-height: 16px;
  letter-spacing: 0.8px;
  font-size: 12px;
  color: #000;
}
.model-box {
  font-family: infiniti-light, sans-serif !important;
}
.model-box:hover {
  background-color: #fff;
  transition: 0.5s;
}

.websiteprimarysubmenu {
  top: 125px !important;
  left: 0px;
  width: 100%;
}

.model-section::-webkit-scrollbar {
  width: 10px;
}
.model-section::-webkit-scrollbar-track {
  background-color: #ccc;
}
.model-section::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.close {
  opacity: initial;
}

.horizontalModelSelector::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}
.gemini-simplify-fixed-submenu {
  position: fixed;
  width: 80%;
  background-color: #fff !important;
  top: 0;
  left: 20%;
  height: 100%;
  overflow-y: auto;
  box-shadow: inset 5px -4px 8px 0px #00000014;
}

.gemini-simplify-fixed-submenu::-webkit-scrollbar {
  display: none;
}
.carSection {
  padding-bottom: 2rem;
}
@media (max-width: 700px) {
  .headingFont {
    font-size: 1.2rem;
  }
  .closeIcon {
    top: 20px;
  }
  .horizontalModelSelector {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
    overflow: auto;
    max-height: 70vh;
  }
  .model-section {
    height: initial;
    overflow: hidden;
    padding: 0;
  }
}
.disclaimer-content-text {
  padding: 4rem 5rem 4rem 5rem;
  text-align: left;
  font-weight: 300;
  font-size: 16px;
}
/* Mobile Devices */
@media only screen and (max-width: 767px) {
  .subheading {
    font-size: 16px;
  }
  .price-container {
    white-space: nowrap;
    margin-top: 10px !important;
  }
  .linkSec {
    white-space: nowrap;
  }
  .linkSec a {
    padding-right: 15px !important;
  }
  em {
    font-size: 12px !important;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1366px) {
  .model-section {
    padding: 2rem 3rem;
  }
  .subheading {
    font-size: 16px;
  }
  .price-container {
    white-space: nowrap;
    margin-top: 10px !important;
  }
  .linkSec {
    white-space: nowrap;
  }
  .linkSec a {
    padding-right: 15px !important;
    margin-top: 6px;
    letter-spacing: 0.26px;
  }
  em {
    font-size: 12px !important;
  }
}

/* Hide by default */
.overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000000000;
}

/* Show when active */
.overlay.active {
  display: block;
}

.popup-box {
  background: white;
  min-width: 300px;
  max-width: 600px;
  padding: 20px;
  border-radius: 5px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.btn-close {
  position: absolute;
  top: 10px;
  right: 15px;
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
}
</style>
